import { CIMSymbolAnimation } from '../models/arcgis-types';

export function isSupportedCIMAnimation(animation: CIMSymbolAnimation): boolean {
    const properties = animation.animatedSymbolProperties;
    return animation.type === 'CIMSymbolAnimationScale' &&
        Number.isFinite(animation.scaleFactor) && (animation.scaleFactor ?? -1) >= 0 &&
        !properties?.randomizeStartTime && !properties?.useEndingDuration && !properties?.reverseAnimation &&
        properties?.repeatType !== 'None' &&
        (properties?.duration === undefined || Number.isFinite(properties.duration));
}

export function isPlayingCIMAnimation(animation: CIMSymbolAnimation): boolean {
    return isSupportedCIMAnimation(animation) && animation.animatedSymbolProperties?.playAnimation === true &&
        (animation.animatedSymbolProperties.duration ?? 3) > 0 && animation.scaleFactor !== 1;
}

export function getCIMAnimationScale(animation: CIMSymbolAnimation | undefined, elapsedSeconds: number): number {
    if (!animation || !isPlayingCIMAnimation(animation)) {
        return 1;
    }
    const properties = animation.animatedSymbolProperties;
    const duration = Math.max(0.05, Math.min(3600, properties?.duration ?? 3));
    const delay = Math.max(0, properties?.repeatDelay ?? 0);
    const time = Math.max(0, elapsedSeconds + (properties?.startTimeOffset ?? 0));
    const period = duration + delay;
    const cycle = Math.floor(time / period);
    const repeat = properties?.repeatType ?? 'Loop';
    let progress = Math.min(1, (time % period) / duration);
    switch (properties?.easing) {
        case 'EaseIn': progress = progress ** 3; break;
        case 'EaseOut': progress = 1 - (1 - progress) ** 3; break;
        case 'EaseInOut': progress = progress < 0.5 ? 4 * progress ** 3 : 1 - (-2 * progress + 2) ** 3 / 2; break;
    }
    if (repeat === 'Oscillate' && cycle % 2 === 1) {
        progress = 1 - progress;
    }
    return 1 + ((animation.scaleFactor ?? 1) - 1) * progress;
}
